export default __webpack_public_path__ + "static/media/IU_Home2.f4f507e8.jpg";